import { render, staticRenderFns } from "./ReceiptEmailComponent.vue?vue&type=template&id=f3983e6a&scoped=true&lang=html&"
import script from "./ReceiptEmailComponent.vue?vue&type=script&lang=js&"
export * from "./ReceiptEmailComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptEmailComponent.vue?vue&type=style&index=0&id=f3983e6a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3983e6a",
  null
  
)

export default component.exports